import { IConsultant } from 'wisestep-api';

export const emptyConsultant: { consultants: IConsultant[] } = {
  consultants: [
    {
      id: '',
      workspaceId: '',
      name: '',
      uniqueId: '',
      email: '',
      source: 'DIRECT',
      sharedToTeams: '',
      sharedToRecruiters: '',
      organization: '',
      locations: [],
      location: {
        area: '',
        city: '',
        continent: '',
        continentCode: '',
        country: '',
        countryCode: '',
        point: '',
        state: '',
        stateCode: '',
        zipCode: '',
        lat: '',
        lon: '',
        id: null,
        internal: false,
        keywords: [],
      },
      willingToRelocate: false,
      visibility: '',
      internalVisibility: '',
      jobTitle: '',
      skills: [
        {
          skill: 'No data Available',
          experienceInYears: 0,
        },
      ],
      visaStatus: '',
      education: '',
      availability: '',
      status: '',
      salaryCurrency: '',
      salaryPerHour: 0,
      preferredLocations: [],
      contractDetails: [],
      ownerName: '',
      ownerId: '',
      ownerPhone: '',
      ownerCompany: '',
    },
  ],
};
